<ng-template #tooltipText>{{ 'Settings.OrganisationWorkgroupsSection.InfoUseClearanceLevels' | translate}}</ng-template>

<div class="container-fuid bg-white default-boxrounded">
    <div class="row">
        <div class="col-12 w-100">
            <h3 class="title">
                <span *ngIf="action === 'add'" translate>Dialog.AddWorkgroup</span>
                <span *ngIf="action !== 'add'" translate>Dialog.EditWorkgroup</span>
            </h3>
        </div>
    </div>
    <ng-template #rt let-r="result">
        {{r.voornaam}} {{r.tussenvoegsels}} {{r.achternaam}}<br />
        <div class="mt-1 information lh-sm">
            {{r.email}}<br />
            {{r.telefoon}}
        </div>
    </ng-template>


    <div class="p-4 pt-1">
        <form class="row needs-validation has-validation" [formGroup]="form">
            <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <label for="name" class="form-label"
                    translate>Settings.OrganisationWorkgroupsSection.WorkgroupName</label>
                <input trim type="text" formControlName="name" id="name" class="form-control"
                    (keyup)="verifyExistingWorkgroup()">
                <app-formcontrol-error-messages [forControl]="workgroupNameControl"></app-formcontrol-error-messages>
                <!-- custom validation to prevent doubles-->
                <ng-container *ngIf="workgroupAlreadyExist">
                    <div class="invalid-feedback" translate>
                        Error.WorkgroupNameAlreadyExist</div>
                </ng-container>
            </div>

            <ng-container *ngIf="action !== 'add'">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                    <span class="pt-5 col-12"
                        translate="Settings.OrganisationBrandingSection.BrandingColours.Options"></span>
                    <div class="mb-3 mt-2 mx-0 p-1 col-12 row text-wrap border rounded lh-base">
                        <div class="d-table form-check form-switch">
                            <input class="switch-form-default form-check-input col-2" type="checkbox" role="switch"
                                id="useClearancelevel" name="useClearancelevel" [checked]="usingClearancelevel"
                                (change)="changeUsingClearancelevel($event)">
                            <label class="form-check-label pt-1 col-10" for="useClearancelevel"
                                translate="Settings.OrganisationWorkgroupsSection.UseClearanceLevels"><app-info-button
                                    labelName="Settings.OrganisationWorkgroupsSection.UseClearanceLevelsTooltip"></app-info-button></label>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                    <label for="InputOrganisationID" class="form-label"
                        translate="Settings.OrganisationWorkgroupsSection.Members"></label>
                </div>
                <div class="input-group">
                    <input type="text" class="form-control" id="MemberToAdd"
                        placeholder="{{ 'Settings.OrganisationWorkgroupsSection.SearchForUser' | translate }}"
                        aria-describedby="addon" pattern="^['()\sa-zA-ZÀ-ÿ\u00f1\u00d10-9.-]*$" [ngbTypeahead]="search"
                        popupClass="dropdown-menu-add-user-workgroup" [resultTemplate]="rt" autocomplete="off"
                        (selectItem)="prefillMember($event)">
                    <div class="input-group-append">
                        <span class="input-group-text no-radius-top-left no-radius-bottom-left cursor-pointer"
                            id="addon" (click)="addMember()" translate="Button.AddMember" placement="top"
                            ngbTooltip="{{'Settings.OrganisationWorkgroupsSection.AddMemberTooltip' | translate}}"
                            [openDelay]="500" [closeDelay]="500"></span>
                    </div>
                </div>

                <app-memberList class="w-100 row-cols-12" [workgroupMembers]="workgroupMembers"
                    (triggerAction)="TriggerAction($event)"
                    [usingClearancelevel]="usingClearancelevel"></app-memberList>
            </ng-container>

            <div class="d-table w-100">
                <span class="float-start"><button type="button" class="btn btn-sm btn-outline-primary" (click)="close()"
                        translate="Button.Back"></button></span>
                <span class="float-end">
                    <button *ngIf="action === 'add'" [disabled]="!form.valid || workgroupAlreadyExist"
                        (click)="addWorkgroup()" type="button" class="btn btn-sm btn-primary ms-1 order-1 float-end"
                        translate="Button.Add"></button>
                    <button *ngIf="action !== 'add'" [disabled]="!form.valid || workgroupAlreadyExist"
                        (click)="editWorkgroup()" type="button" class="btn btn-sm btn-primary ms-1 order-1 float-end"
                        translate="Button.SaveChanges"></button>
                </span>
            </div>
        </form>
    </div>
</div>